'use strict';

class rmTimeInput {

    constructor($scope) {
        this.$scope = $scope;
        this.timeType = $scope.timeType;
        this.inputName = $scope.inputName;
        this.form = $scope.form;

        this.observe = this.observe.bind(this);

        if ($scope.yModel) {
            $scope.yModel.observe(this.observe);
            this.observe();
        }

        if ($scope.strictTimestamp && !$scope.yModel) {
            $scope.model = this.dateFormatter($scope.model);
        }

        // default use the hour regex
        this.validationRegex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/;
        this.convertRegex = /[0-9]{0,2}[:.-][0-9]{0,2}([:.-][0-9]{0,2})?/;
        this.timeStaps = 3;
        if ($scope.timeType === 'minute') {
            this.validationRegex = /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])$/;
            this.convertRegex = /[0-9]{0,2}[:.-][0-9]{0,2}/;
            this.timeStaps = 2;
        } else if ($scope.timeType === 'second') {
            this.validationRegex = /^(([0-9]{0,3}):)?([0-5][0-9])$/;
            this.convertRegex = /[0-9]{0,3}[:.-][0-9]{0,2}/;
            this.timeStaps = 2;
        }

        $scope.$on('$destroy', () => {
            if ($scope.yModel) {
                $scope.yModel.unobserve(this.observe);
            }
        });
    }


    observe() {
        this.$scope.model = encodeTime(this.$scope.yModel.toString(), this.$scope.timeType, this.$scope.useTimezone);
        if (this.$scope.strictTimestamp) {
            this.$scope.model = this.dateFormatter(this.$scope.model);
        }
    }


    fixTimePart(model, max = 2) {
        model = model || '';
        if (model.length === 0) {
            return '00';
        } else if (model.length === 1) {
            return '0' + model;
        }
        return model.substr(0, max);
    }


    strToTime(model) {
        if (model && model.length !== 0) {
            if (this.convertRegex.test(model)) {
                let splices = model.split(/[:.\-]/).slice(0, this.timeStaps);
                splices[0] = this.fixTimePart(splices[0], 3);
                for (let i = 1; i < this.timeStaps; i++) {
                    splices[i] = this.fixTimePart(splices[i]);
                }
                return splices.join(':');
            }
            model = model.replace(/:/, '');
            if (/[0-9]+/.test(model)) {
                let splices = model.split(/(?=(?:..)*$)/).slice(0, this.timeStaps);
                for (let i = 0; i < this.timeStaps; i++) {
                    splices[i] = this.fixTimePart(splices[i]);
                }
                if (this.$scope.timeType == 'second') {
                    if (splices[1] == '00') {
                        return '00:' + splices[0];
                    }
                }
                return splices.join(':');
            }
        }
        return model;
    }


    dateFormatter(value) {
        if (!value) return value;
        let currentTime = moment(value);
        if (!this.datetime) {
            this.datetime = currentTime.format('YYYY-MM-DD');
            if (this.datetime === 'Invalid date') {
                this.datetime = moment().format('YYYY-MM-DD');
            }
        }
        return currentTime.format('HH:mm:ss');
    }


    dateParser(value) {
        if (this.$scope.useTimezone) {
            return moment.tz(this.datetime + ' ' + value, this.$scope.useTimezone).format();
        }
        return moment(this.datetime + ' ' + value).format();
    }


    applyError(error, status) {
        if (this.form && this.form[this.inputName]) {
            this.form[this.inputName].setValidity(error, !status);
        }
    }


    getVal() {
        if (this.form && this.form[this.inputName]) {
            return this.form[this.inputName].$viewValue;
        }
        return this.$scope.model;
    }


    onBlur() {
        const $scope = this.$scope;
        let value = this.getVal();
        let model = this.strToTime(value);

        if (!this.validationRegex.test(model)) {
            if (!this.form || !this.form[this.inputName]) {
                if ((value || '') === '') {
                    $scope.error = false;
                    $scope.model = $scope.oldModel;
                } else {
                    $scope.error = true;
                }
            }
            return;
        }
        $scope.error = false;

        let time = decodeTime(model || '', this.timeType).toString();
        if ($scope.strictTimestamp) {
            time = this.dateParser(time);
        }

        if ($scope.yModel) {
            $scope.yModel.delete(0, $scope.yModel.length);
            $scope.yModel.insert(0, time);
        }

        $scope.model = model;
        $scope.onChange(this, time);
    }

}

let encodeTime = (string, type, useTimezone) => {
    if (type === 'hour' && useTimezone) {
        string = moment.tz(string, useTimezone).format('YYYY-MM-DDTHH:mm:ss');
    } else if (type === 'second') {
        if (!string) {
            return '00:00';
        }
        let sec_num = parseInt(string, 10);
        let minutes = Math.floor(sec_num / 60);
        let seconds = sec_num - (minutes * 60);
        if (minutes < 10) minutes = '0' + minutes;
        if (seconds < 10) seconds = '0' + seconds;
        return minutes + ':' + seconds;
    }
    return string;
};

let decodeTime = (string, type) => {
    if (type === 'second' && string) {
        var time = string.split(':');
        return (+time[0]) * 60 + (+time[1]);
    }
    return string;
};

module.exports = [() => {
    return {
        templateUrl: (element, args) => {
            if (args && args.type === 'native') {
                return '/partial/app.partials.app.rm_time_input_native';
            }
            return '/partial/app.partials.app.rm_time_input';
        },
        replace: true,
        require: '?ngModel',
        controller: [
            '$scope',
            rmTimeInput
        ],
        controllerAs: 'ctrl',
        scope: {
            label: '=',
            classes: '@',
            timeType: '@',
            inputName: '@',
            form: '=',
            yModel: '=',
            useTimezone: '=',
            disableInput: '=',
            strictTimestamp: '=',
        },
        link: ($scope, element, attributes, ngModel) => {
            if (!ngModel) return;

            $scope.oldModel = $scope.model;

            $scope.onChange = (ctrl, value) => {
                $scope.oldModel = value;
                if ($scope.strictTimestamp) {
                    ngModel.$setViewValue(ctrl.dateParser(value), $scope.timeType);
                } else {
                    ngModel.$setViewValue(value, $scope.timeType);
                }
            };
            ngModel.$render = () => {
                if (!$scope.yModel) {
                    $scope.model = encodeTime(ngModel.$modelValue, $scope.timeType, $scope.useTimezone);
                }
            };
        },
    };
}];
